import { Text } from 'blaze-ui/Text/Text'
import Styles from './EmptyFile.module.scss'
import cx from 'classnames'

interface Props {
  type?: 'project' | 'doc' | 'design' | 'preview'
  isNested?: boolean
}

export const EmptyFile = ({ type, isNested = false }: Props) => {
  let url = null
  if (type === 'project')
    url = 'https://res.cloudinary.com/almanac/image/upload/v1715725898/Home%20Card%20Previews/emptyFolder_svebzu.png'
  if (type === 'doc')
    url = 'https://res.cloudinary.com/almanac/image/upload/v1715725897/Home%20Card%20Previews/emptyDoc_l0foqy.png'
  if (type === 'design')
    url = 'https://res.cloudinary.com/almanac/image/upload/v1715725897/Home%20Card%20Previews/emptyDesign_by2po1.png'
  if (type === 'preview')
    url = 'https://res.cloudinary.com/almanac/image/upload/v1715778542/Home%20Card%20Previews/emptyPreview_bgzwd7.png'

  let label = null
  if (type === 'project') label = 'This project is empty'
  if (type === 'doc') label = 'This doc is empty'
  if (type === 'design') label = 'This design is empty'
  if (type === 'preview') label = "Preview isn't available"

  return (
    <div className={cx(Styles.emptyFile, { [Styles.isNested]: isNested })}>
      {url && <img className={Styles.emptyIcon} src={url} alt={type} />}
      <Text variant="label">{label}</Text>
    </div>
  )
}
